// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Whether to accept IPv6 router advertisements.
 *
 * Three values, not a bool, because the renderer has three behaviours: it
 * emits `accept-ra: true`, emits `accept-ra: false`, or emits nothing and
 * lets the kernel default (accept) stand. A bool cannot say "nothing", and
 * both ways of collapsing it are wrong — always emitting turns every
 * untouched form into `accept-ra: false`, which costs a SLAAC site its IPv6
 * default route at first boot, and emitting only on true makes it impossible
 * to deliberately refuse advertisements, which is the reason the knob exists.
 */
export enum AcceptRa {
  /**
   * Say nothing; the kernel default stands.
   */
  UNSET = 0,
  ENABLED = 1,
  DISABLED = 2,
}
